export var FilterType;
(function (FilterType) {
    FilterType["Approver"] = "approver";
    FilterType["Accountant"] = "accountant";
})(FilterType || (FilterType = {}));
